var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Calculates statistics about the pivot table metadata.
 */
export function getPivotMetadataStats(rowsAttributes, columnsAttributes, measures) {
    return {
        rowsCount: rowsAttributes.length,
        columnsCount: columnsAttributes.length,
        measuresCount: measures.length,
    };
}
/**
 * Converts sort direction to JAQL sort direction.
 */
export function convertSortDirectionToJaqlSort(direction) {
    switch (direction) {
        case 'sortAsc':
            return 'asc';
        case 'sortDesc':
            return 'desc';
        default:
            return 'none';
    }
}
/**
 * Prepares JAQL sort options for pivot table row.
 */
export function preparePivotRowJaqlSortOptions(sort, rowIndex, metadataStats) {
    const sortDirection = convertSortDirectionToJaqlSort(sort.direction);
    const isLastRow = rowIndex === metadataStats.rowsCount - 1;
    const sortDetails = {
        dir: sortDirection,
        initialized: true,
        field: sort.by && 'valuesIndex' in sort.by
            ? metadataStats.rowsCount + metadataStats.columnsCount + sort.by.valuesIndex
            : rowIndex,
    };
    if (isLastRow) {
        sortDetails.sortingLastDimension = true;
    }
    if (sort.by) {
        sortDetails.measurePath = (sort.by.columnsMembersPath || []).reduce((path, columnMember, columnIndex) => (Object.assign(Object.assign({}, path), { [metadataStats.rowsCount + columnIndex]: columnMember })), {});
    }
    return {
        sort: sortDirection,
        sortDetails,
    };
}
/**
 * Normalizes sorting for the last row of the pivot table.
 *
 * According to the existing pivot JAQL structure, the sorting configuration of the last row
 * should be located inside the target measure metadata in some cases.
 * This function moves the sorting configuration from the last row metadata to the target measure metadata
 * if it actually related to that measure.
 */
export function normalizeLastRowSorting(metadata, metadataStats) {
    if (metadataStats.rowsCount === 0) {
        return;
    }
    const lastRowIndex = metadataStats.rowsCount - 1;
    const lastRowMetadata = metadata[lastRowIndex];
    const _a = lastRowMetadata.jaql, { sortDetails, sort } = _a, jaqlWithoutSortOptions = __rest(_a, ["sortDetails", "sort"]);
    const isSortedByMeasure = sortDetails && sortDetails.field !== lastRowIndex && sortDetails.field < metadata.length;
    if (isSortedByMeasure) {
        const targetMeasureMetadata = metadata[sortDetails.field];
        targetMeasureMetadata.jaql.sortDetails = sortDetails;
        targetMeasureMetadata.jaql.sort = sort;
        lastRowMetadata.jaql = jaqlWithoutSortOptions;
    }
}
//# sourceMappingURL=pivot-query-utils.js.map